/* bz-lag: DOA-claim photo picker + share-sheet handler for the Live Arrival Guarantee page.
   Behaviour for sections/bz-lag.liquid's .bz-lag-claim-form (data-bz-lag-claim). Reads the
   merchant contact email from data-contact-email on that element (the .liquid sets it from
   section.settings.contact_email). External file => use querySelector to find the root, not
   document.currentScript. */
(function () {
  var root = document.querySelector('[data-bz-lag-claim]');
  if (!root) return;
  var input = root.querySelector('[data-bz-lag-photo-input]');
  var label = root.querySelector('[data-bz-lag-photo-count]');
  var shareBtn = root.querySelector('[data-bz-lag-share]');
  var fallback = root.querySelector('[data-bz-lag-fallback]');
  var contactEmail = root.dataset.contactEmail || '';
  var noFilesLabel = root.dataset.noFilesLabel || 'No files selected';
  var oneFileLabel = root.dataset.oneFileLabel || '1 file selected';
  var manyFilesLabel = root.dataset.manyFilesLabel || '[count] files selected';
  var pickFilesAlert = root.dataset.pickFilesAlert || 'Pick at least one photo first.';

  input.addEventListener('change', function () {
    var n = input.files ? input.files.length : 0;
    label.textContent = n === 0 ? noFilesLabel : (n === 1 ? oneFileLabel : manyFilesLabel.replace('[count]', n));
  });

  shareBtn.addEventListener('click', function () {
    var files = input.files ? Array.from(input.files) : [];
    var orderNum = (root.querySelector('#bz-lag-order') || {}).value || '';
    var name = (root.querySelector('#bz-lag-name') || {}).value || '';
    var subject = 'DOA claim, order ' + (orderNum || '#');
    var body = 'Photos and video for the DOA claim.\n\nName: ' + name + '\nOrder: ' + orderNum;

    if (files.length === 0) {
      alert(pickFilesAlert);
      return;
    }

    if (navigator.canShare && navigator.canShare({ files: files })) {
      navigator.share({
        files: files,
        title: subject,
        text: body
      }).catch(function () { /* user cancelled */ });
      return;
    }

    fallback.hidden = false;
    var mailto = 'mailto:' + encodeURIComponent(contactEmail) +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body + '\n\n(Attach the photos to this email after it opens.)');
    window.location.href = mailto;
  });
})();
